import styled from 'styled-components';

export interface ContainerProps {
  gap?: string;
}

export const StyledGridContainer = styled.div<ContainerProps>`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  margin-top: 1rem;
  gap: ${(props) => props.gap || '1rem'};

  @media (min-width: 992px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: ${(props) => props.gap || '1.5rem'};
  }
`;
